import { ImageViewer } from "./ImageViewer";
import { Image } from "../types/images";

interface DesktopImageViewerProps {
  images: Image[];
  isOpen: boolean;
  onClose: () => void;
}

export const DesktopImageViewer = ({
  images,
  isOpen,
  onClose,
}: DesktopImageViewerProps) => {
  return (
    <ImageViewer
      images={images}
      isOpen={isOpen}
      onClose={onClose}
      carouselId="desktopImageViewer"
    />
  );
};
